module.exports = __webpack_public_path__ + "static/conforama-487f13a37837a4b274c0a1b870b04632.png";